import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { DownloadIcon } from '@navi/web-ui/lib/icons';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { handleDownloadButtonClick } from '../action';
import { ReportStatusEnum, ReportStatusDisplayNames } from '../constant';
import { formatRequestedAt } from '../utils';
import styles from './index.module.scss';

export const VIEW_REPORT_STATUS_COLUMN_DEFS: NaviTableColumnDef<any, any>[] = [
  {
    accessorKey: 'reportName',
    header: 'Report Name',
    size: 200,
    enableSorting: true,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex justify-center">
          <Typography variant="p3" color="var(--navi-color-gray-c2)" className={styles.reportName}>
            {data?.reportName}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'requestedAt',
    header: 'Requested At',
    size: 180,
    enableSorting: true,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex justify-center">
          <Typography variant="p3" color="var(--navi-color-gray-c2)">
            {formatRequestedAt(data?.requestedAt)}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 160,
    enableSorting: true,
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex justify-center">
          <Typography variant="p3" color="var(--navi-color-gray-c2)">
            {ReportStatusDisplayNames[data?.status as ReportStatusEnum] || data.status}
          </Typography>
        </div>
      );
    }
  },
  {
    accessorKey: 'actions',
    header: 'Action',
    size: 100,
    cell: ({ row }) => {
      const data = row.original;
      const isDownloadable = data?.downloadable;
      return isDownloadable ? (
        <div className="flex justify-center">
          <Button
            variant="text"
            startAdornment={<DownloadIcon color="var(--navi-color-blue-base)" />}
            onClick={() => handleDownloadButtonClick(data?.reportType, data?.requestId)}
          >
            Download
          </Button>
        </div>
      ) : (
        <div className="flex justify-center">
          <Typography variant="p3" color="var(--navi-color-gray-c1)">
            -
          </Typography>
        </div>
      );
    }
  }
];
